export enum EProductPublishScope {
  PRODUCT = 'product',
  VARIANTS = 'variants',
  IMAGES = 'images',
  PRICES = 'prices',
}
